import React, { useEffect, useState } from 'react'
import { SubIndexSelectButton, SvgCarretDownIcon, SvgCarretLeftIcon } from '../LeftPanel.styled'
import { COLOR, SUB_INDICES_INFO } from 'constant'
import { Box } from '@mui/material'

const SubIndexSelector: React.FC<{
  subIndexName: string
  subIndexCode: string
  onClick: () => void
  isSelected: boolean
  isDisabled: boolean
}> = ({ subIndexName, subIndexCode, onClick, isSelected, isDisabled }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleExpansion = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    event.stopPropagation()
    if (!isSelected) {
      onClick()
    }
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    isSelected && setIsOpen(true)
  }, [isSelected])

  return (
    <>
      <SubIndexSelectButton
        style={{
          background: isSelected ? COLOR.DARK : COLOR.WHITE,
          color: isSelected ? COLOR.TEXT : COLOR.NAVY,
          userSelect: 'none',
          textAlign: 'center',
          flex: '1 1',
          lineHeight: 1,
          width: '65%',
        }}
        onClick={onClick}
        disabled={isDisabled}
      >
        <span style={{ width: '100%' }}>{subIndexName.toUpperCase()}</span>
        <span
          style={{ width: '18px', height: '18px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          onClick={(e) => toggleExpansion(e)}
        >
          {isOpen && isSelected ? (
            <SvgCarretLeftIcon iconColor={isSelected ? COLOR.TEXT : COLOR.CARRET} width='14px' height='14px' />
          ) : (
            <SvgCarretDownIcon iconColor={isSelected ? COLOR.TEXT : COLOR.CARRET} width='18px' height='18px' />
          )}
        </span>
      </SubIndexSelectButton>
      {isOpen && isSelected && (
        <Box className="keyIndicatorsArea">
          <h3>Key Indicators Included:</h3>
          <ul>
            {SUB_INDICES_INFO.find((i) => i.indexCode === subIndexCode)?.indicators.map((i) => {
              return <li key={i.metricName}>{i.metricName}</li>
            })}
          </ul>
        </Box>
      )}
    </>
  )
}

export default SubIndexSelector
